import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CityWithCatalogCounterViewModel } from '@common/model/location/citiesWithCatalogCounterRequest';

type ICitiesCatalogCounterDict = {
  [cityId: number]: {
    [catalogType in CatalogItemType]?: {
      [careerId in CareerId]?: number;
    };
  };
};

export const buildCitiesCatalogCounterDict = (arr: CityWithCatalogCounterViewModel[] | undefined): ICitiesCatalogCounterDict => {
  return (arr ?? []).reduce<ICitiesCatalogCounterDict>((acc, item) => {
    if (!acc[item.cityId]) {
      acc[item.cityId] = {};
    }

    if (!acc[item.cityId][item.catalogType]) {
      acc[item.cityId][item.catalogType] = {};
    }

    (acc[item.cityId][item.catalogType] as NonNullable<ICitiesCatalogCounterDict[number][CatalogItemType]>)[item.careerId] = item.count;

    return acc;
  }, {});
};
